import React from "react";
import Counter from "./Counter";
import Container from "../Container/Index";
import numberBanner from '../../images/number-banner.jpeg'
import ImageTag from "../ImageTag/Index";
import Title from "../Title/Index";

const getDecimalPlaces = (num) => {
  if (num === undefined || num === null) return 0;
  const str = num.toString();
  return str.includes('.') ? str.split('.')[1].length : 0;
};

const Numbers = ({ countersData, numbersection }) => {
  return (
    <>
      <Container _parentClass={'flex flex-wrap p-100 pt-0'}>
        <div className="flex flex-wrap col-lg-11 w-full m-auto text-center">
          <div className="w-full md:w-200 mx-auto">
            <Title
              firstHeading={numbersection?.heading}
              secondHeading={numbersection?.title}
              subTitle={numbersection?.descp}
            />
          </div>

          <div className='w-full relative lg:w-[90%] m-auto'>
            <ImageTag
              ImagePath={numberBanner}
              ImageAlt={'number banner'}
              ImageClass={'bgImage md:h-[70vh] h-dvh object-cover flex-center w-full'}
            />
            <span className="absolute bg-black/40 inset-0 w-full h-full" />

            <div className="numbercount absolute top-0 bottom-0 left-0 right-0 float-start flex items-center w-full justify-center">
              <div className={`numberrow position-absolute md:w-full md:float-start w-[80%] mx-auto items-center flex-wrap justify-center md:grid grid-cols-3 gap-10`}>
                {countersData &&
                  Array.isArray(countersData) &&
                  countersData.map((counter, index) => {
                    // Use decimals from data if provided, else auto-detect from endValue string
                    const decimals = counter.decimals ?? getDecimalPlaces(counter.endValue);

                    return (
                      <div key={index} className="numbercolumn w-full">
                        {counter.startValue !== undefined && counter.endValue !== undefined ? (
                          <div className="countercount">
                            <Counter
                              startValue={Number(counter.startValue)}
                              endValue={parseFloat(counter.endValue)}
                              speed={counter.speed}
                              decimals={decimals}
                              className="m-0 p-0"
                            />
                            <span>{counter.Plus}</span>
                            <span>{counter.Heading}</span>
                          </div>
                        ) : (
                          <div className="countercount">
                            <span>{counter.Plus}</span>
                            <span>{counter.Heading}</span>
                          </div>
                        )}
                        <div className="countercont md:w-[50%] w-full mx-auto">
                          <p>{counter.label}</p>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>

          </div>
        </div>
      </Container>
    </>
  );
};

export default Numbers;